// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LmTry","navbar":"styles_navbar__uGNss","logo":"styles_logo__YYpbI","lista":"styles_lista__eEIh8","item":"styles_item__6IX0l"};